import { useState } from "react";

const StarRating = ({
  disabled = false,
  totalStars = 5,
  value = 0,
  onChange,
  size = 24,
}) => {
  const [hovered, setHovered] = useState(null);

  return (
    <div className="d-flex align-items-center ">
      {[...Array(totalStars)].map((_, index) => {
        const ratingValue = index + 1;

        return (
          <span
            key={ratingValue}
            className="star"
            style={{
              fontSize: size,
              cursor: "pointer",
              color: ratingValue <= (hovered || value) ? "#ffc107" : "#e4e5e9",
            }}
            onClick={() => !disabled && onChange(ratingValue)}
            onMouseEnter={() => !disabled && setHovered(ratingValue)}
            onMouseLeave={() => setHovered(null)}
          >
            ★
          </span>
        );
      })}
    </div>
  );
};

export default StarRating;